import { Reveal } from "@/lib/reveal";
import { IMAGES } from "@/data";
import { useLang } from "@/lib/lang";

export default function Story() {
  const { t } = useLang();
  return (
    <section className="pad alt section-line" id="story" data-testid="story-section">
      <div className="two-col even">
        <div>
          <Reveal className="eyebrow">{t.story.eyebrow}</Reveal>
          <Reveal delay={0.05}>
            <h2 className="mid" data-testid="story-title">{t.story.title}</h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="body sm">{t.story.p1}</p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="body sm" style={{ marginBottom: 32 }}>{t.story.p2}</p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="story-quote">{t.story.quote}</p>
          </Reveal>
        </div>
        <Reveal delay={0.1} className="frame p32" data-testid="story-image">
          <img src={IMAGES.story} alt="A checkpoint at night" loading="lazy" />
        </Reveal>
      </div>
    </section>
  );
}
